<a [href]="href()" rel="noopener noreferrer" target="_blank">
  <ion-icon [iconName]="icon()" />
</a>
